module.exports = {
    nowDownload: '立刻下载',
    copyRight: '版权所有 ©格创东智科技有限公司 2018-2021 保留一切权利 粤ICP备18113976号-11',
    androidDown: '安卓下载',
    iosDown: '苹果下载',
    identityVerification: '身份验证',
    onlyTCL: '仅允许TCL用户使用,请验证身份后下载',
    oaPlaceholder: '请输入OA账号/邮箱',
    iosLogin: '登录',
    pwdPlaceholder: '密码',
}